module.exports = __webpack_public_path__ + "static/media/10_file_import_requirements_and_best_practices.43a4eed4.png";